module.exports = __webpack_public_path__ + "img/2_david_h.78dd24c6.png";